import { HttpClient, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { MatIconRegistry } from '@angular/material';
import { BrowserModule, DomSanitizer } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AppRoutingModule } from './/app-routing.module';
import { AppComponent } from './app.component';
import { PageNotFoundComponent } from './auth/page-not-found/page-not-found.component';
import { SharedModule } from './shared.module';
import { PrivacyDialogComponent } from './dialogs/privacy-dialog/privacy-dialog.component';
import { CargoDetailsComponent } from './dialogs/cargo-details/cargo-details.component';
import { HblEntryValidationComponent } from './dialogs/hbl-entry-validation/hbl-entry-validation.component';
import { EntrynumGuideDialogComponent } from './dialogs/entrynum-guide-dialog/entrynum-guide-dialog.component';
import { IncidentalFeeBreakdownPopupComponent } from './dialogs/incidental-fee-breakdown-popup/incidental-fee-breakdown-popup.component';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [
    AppComponent,
    PageNotFoundComponent,
    PrivacyDialogComponent,
    CargoDetailsComponent,
    HblEntryValidationComponent,
    EntrynumGuideDialogComponent,
    IncidentalFeeBreakdownPopupComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    TranslateModule.forRoot({
      useDefaultLang: true,
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    SharedModule
  ],
  entryComponents: [
    PrivacyDialogComponent,
    CargoDetailsComponent,
    HblEntryValidationComponent,
    EntrynumGuideDialogComponent,
    IncidentalFeeBreakdownPopupComponent
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(matIconRegistry: MatIconRegistry, domSanitizer: DomSanitizer) {
    matIconRegistry.addSvgIconSet(domSanitizer.bypassSecurityTrustResourceUrl('./assets/mdi.svg'));
  }
}
